export default "__VITE_ASSET__56d4a100__"